var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaveTheWayForAiAdoption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4985 78.2144C28.4985 80.3195 30.1969 82.0265 32.2955 82.0265H56.1735C56.2777 82.0265 56.382 82.0231 56.4829 82.013C58.8371 81.8275 60.3303 79.3782 59.6106 77.1247L58.5546 73.8388C57.5658 70.752 57.0513 67.537 57.021 64.3018",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2167 1.20605C16.6634 3.24706 6.30507 12.7605 5.6089 26.9599C5.59545 27.2129 5.71316 27.6144 5.89813 28.0799C6.96423 30.7484 6.80617 33.7475 5.50128 36.3047L1.50592 44.1347C-0.0343783 47.1237 2.1281 50.6862 5.48447 50.6862L7.70748 50.9696C9.91031 51.2428 9.54373 52.6328 9.54373 54.5827V61.7616C9.54373 67.1189 14.2386 71.2582 19.5389 70.57L24.7819 69.8886C26.7527 69.6322 28.5015 71.1739 28.5015 73.1677V78.2179",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9331 23.5053V21.3563C33.9331 19.8349 35.1606 18.6035 36.6774 18.6035H52.1241C53.6409 18.6035 54.8684 19.8349 54.8684 21.3563V36.8512C54.8684 38.3726 53.6409 39.604 52.1241 39.604H36.6774C35.1606 39.604 33.9331 38.3726 33.9331 36.8512V23.5053Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8682 21.5756H68.0683L70.0122 10.9219",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9333 20.9785H28.2261",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9932 36.7021H66.6059",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2124 39.874V45.0423",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0996 50.9151L52.9888 39.6035",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7305 40.3086V45.2779",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1963 9.75391V18.2486",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9334 33.1738H23.7769",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1975 55.3984C61.1975 57.8982 59.1762 59.9258 56.6842 59.9258C54.1921 59.9258 52.1709 57.8982 52.1709 55.3984C52.1709 52.8986 54.1921 50.8711 56.6842 50.8711C59.1762 50.8711 61.1975 52.8986 61.1975 55.3984Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5663 53.1792C42.5812 52.9304 44.0135 51.0901 43.7654 49.0689C43.5173 47.0477 41.6828 45.611 39.6678 45.8599C37.6529 46.1088 36.2207 47.949 36.4688 49.9702C36.7169 51.9914 38.5514 53.4281 40.5663 53.1792Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2978 30.4147C79.2978 32.8268 77.3472 34.7834 74.9426 34.7834C72.538 34.7834 70.5874 32.8268 70.5874 30.4147C70.5874 28.0026 72.538 26.0459 74.9426 26.0459C77.3472 26.0459 79.2978 28.0026 79.2978 30.4147Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1929 9.80532C73.3184 9.54277 74.8293 7.6015 74.5676 5.46937C74.3058 3.33723 72.3706 1.82164 70.2451 2.08418C68.1196 2.34673 66.6087 4.28801 66.8704 6.42014C67.1321 8.55227 69.0674 10.0679 71.1929 9.80532Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2152 5.02804C43.2152 7.2546 41.4159 9.05609 39.1996 9.05609C36.9833 9.05609 35.1841 7.25123 35.1841 5.02804C35.1841 2.80486 36.9833 1 39.1996 1C41.4159 1 43.2152 2.80486 43.2152 5.02804Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3745 51.7964C77.3745 54.1107 75.5046 55.9864 73.1975 55.9864C70.8904 55.9864 69.0205 54.1107 69.0205 51.7964C69.0205 49.4822 70.8904 47.6064 73.1975 47.6064C75.5046 47.6064 77.3745 49.4822 77.3745 51.7964Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5449 24.4424C27.4531 23.6495 28.3593 21.4551 27.5689 19.5409C26.7785 17.6268 24.5908 16.7178 22.6826 17.5107C20.7744 18.3035 19.8683 20.498 20.6587 22.4121C21.4491 24.3263 23.6367 25.2352 25.5449 24.4424Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7437 36.7021L70.3523 45.1428",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5172 30.4541H54.9932",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaveTheWayForAiAdoption);
export default __webpack_public_path__ + "static/media/pave-the-way-for-AI-adoption.d7b482d2ffef6cd6548aef59134ffd94.svg";
export { ForwardRef as ReactComponent };